import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import BaseModal from 'components/BaseModal';

const Props = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default function ThanksModal({ open, onClose }) {
  return (
    <BaseModal
      size="sm"
      open={open}
      title={<b>Thanks for the feedback</b>}
      content={
        <Box px={2}>
          <Box mb={4}>
            <Typography>Your opinion helps us to improve your experience.</Typography>
          </Box>

          <img src="/images/feedback-thanks.svg" alt="Feedback thanks" />
        </Box>
      }
      actionButton={false}
      cancelButton={false}
      onActionClick={onClose}
      onClose={onClose}
    />
  );
}

ThanksModal.propTypes = Props;
